import { Dictionary } from '@/src/lib/dictionary/types';
import { ValidationConfigType } from '@/src/lib/validation/validation.config';
import { TenantConfig } from '@/src/lib/store/tenants-config.ts';
import { getTenantConfig } from '@/src/lib/store/business/get-tenants-config-value';

export class FormValidationModel {
  protected EMAIL_REQUIRED_MESSAGE: string = '';

  protected REQUIRED_MESSAGE: string = '';

  protected VALIDATION_CONFIG: ValidationConfigType = {} as ValidationConfigType;

  protected DICT: Dictionary = {} as Dictionary;

  protected TENANT_CONFIG: TenantConfig = {} as TenantConfig;

  constructor(validationConfig: ValidationConfigType, dict: Dictionary) {
    this.EMAIL_REQUIRED_MESSAGE = dict.messages.form.validation.email.toString();
    this.REQUIRED_MESSAGE = dict.messages.form.validation.required.toString();
    this.VALIDATION_CONFIG = validationConfig;
    this.DICT = dict;
    this.TENANT_CONFIG = getTenantConfig();
  }
}
